import {
  BooleanParam,
  DateTimeParam,
  NumberParam,
  StringParam,
  withDefault,
} from 'use-query-params';

import { RgCraV2RiskHistoryOrderBy } from '@/globalTypes';
import {
  RgV2EventTypeParam,
  RgV2RiskHistoryOrderByParam,
} from '@/utils/query/params';

export const queryParams = {
  after: StringParam,
  before: StringParam,
  desc: withDefault(BooleanParam, true),
  eventType: RgV2EventTypeParam,
  first: withDefault(NumberParam, 20),
  from: DateTimeParam,
  last: NumberParam,

  orderBy: withDefault(
    RgV2RiskHistoryOrderByParam,
    RgCraV2RiskHistoryOrderBy.processedAt,
  ),
  to: DateTimeParam,
};
